import { Card, CardContent } from "ui/components/card";

import { ADD_USER } from "icons";
import AvatarDisplay from "components/avatar/display";
import { Badge } from "ui/components/badge";
import Icon from "components/icon";
import classNames from "classnames";
import { cn } from "utils";

export function EvtEmployeePlaceholderCard({ onClick }) {
  return (
    <Card className={classNames(" h-max py-3")} onClick={onClick}>
      <CardContent>
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 relative">
          <div className="size-10 bg-secondary rounded-full flex place-items-center place-content-center">
            <Icon className="size-4 text-neutral-500" icon={ADD_USER} />
          </div>

          <div className="space-y-0.5">
            <h3 className="text-base text-neutral-500 leading-6 text-card-foreground">
              Select Employee
            </h3>
            <p className="text-sm font-normal leading-5 text-muted-foreground"></p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
